import QuotationResultFiltersFcl from "./quotation-result-filters-fcl.component";

export default QuotationResultFiltersFcl;
